import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import { QueryConfig } from '@/lib/tanstack-query';
import { Order } from '@/types/api/order';

export const getOrder = async ({ orderId }: { orderId: string }): Promise<Order> => {
  return (await api.get(`/orders/${orderId}`)).data;
};

export const getOrderQueryOptions = (orderId: string) => {
  return queryOptions({
    queryKey: ['orders', orderId],
    queryFn: () => getOrder({ orderId }),
    enabled: Boolean(orderId),
  });
};

type UseOrderOptions = {
  orderId: string;
  queryConfig?: QueryConfig<typeof getOrderQueryOptions>;
};

export const useOrder = ({ orderId, queryConfig }: UseOrderOptions) => {
  return useQuery({
    ...getOrderQueryOptions(orderId),
    ...queryConfig,
  });
};

export const useOrderSuspense = ({ orderId, queryConfig }: UseOrderOptions) => {
  return useSuspenseQuery({
    ...getOrderQueryOptions(orderId),
    ...queryConfig,
  });
};
